<template>
    <b-modal
        size="lg"
        v-model="itemVisible"
        :title="itemModel.id ? 'Edit Item' : 'Create Item'"
        @ok="handleOk"
    >
        <b-form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-row>
                <!--b-col cols="6">
                    <b-form-group
                        id="input-group-order_item_type_id"
                        label="Type:"
                        label-for="input-order_item_type_id"
                        invalid-feedback="Type is required"
                    >
                        <b-form-select
                            id="input-order_item_type_id"
                            name="input-order_item_type_id"
                            size="sm"
                            v-model="itemModel.order_item_type_id"
                            :options="itemTypeOptions"
                            required
                        >
                        </b-form-select>
                    </b-form-group>
                </b-col-->

                <b-col cols="12">
                    <b-form-group
                        id="input-group-item"
                        label="Master Item:"
                        label-for="input-item"
                        invalid-feedback="Master Item is required"
                    >
                        <master-item-type-ahead
                            @set-master-item="setMasterItem"
                            :type="itemModel.order_item_type_id"
                            v-model="itemModel.master_item_id"
                        ></master-item-type-ahead>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group
                        id="input-group-description"
                        label="Description:"
                        label-for="input-description"
                    >
                        <b-form-input
                            id="input-description"
                            name="input-description"
                            size="sm"
                            placeholder="Description Name"
                            v-model="itemModel.description"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group
                        id="input-group-section_from_id"
                        label="From Bin:"
                        label-for="input-section_from_id"
                    >
                        <b-form-select
                            id="input-section_from_id"
                            name="input-section_from_id"
                            size="sm"
                            v-model="itemModel.section_from_id"
                            :options="warehouse_section_options"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group
                        id="input-group-section_to_id"
                        label="To Bin:"
                        label-for="input-section_to_id"
                    >
                        <b-form-select
                            id="input-section_to_id"
                            name="input-section_to_id"
                            size="sm"
                            v-model="itemModel.section_to_id"
                            :options="warehouse_section_options"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group
                        id="input-group-quantity"
                        label="Quantity:"
                        label-for="input-quantity"
                    >
                        <b-form-input
                            id="input-quantity"
                            name="input-quantity"
                            size="sm"
                            placeholder="Quantity"
                            type="number"
                            v-model="itemModel.quantity"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="6">
                    <b-form-group
                        id="input-group-price"
                        label="price:"
                        label-for="input-price"
                    >
                        <b-form-input
                            id="input-price"
                            name="input-price"
                            size="sm"
                            placeholder="Price"
                            type="number"
                            min="0.01"
                            max="100000"
                            v-model="itemModel.price"
                        />
                    </b-form-group>
                </b-col>
            </b-form-row>
            <view-assets
                v-model="itemModel.assets"
                :customer-id="order.customer_id"
            />
        </b-form>
        <template #modal-footer="{ ok }">
            <b-button
                :disabled="submitting"
                variant="secondary"
                @click="itemVisible = false"
                >Cancel</b-button
            >
            <b-button :disabled="submitting" variant="primary" @click="ok">{{
                submitTitle
            }}</b-button>
        </template>
    </b-modal>
</template>

<script>
import { uuidv4 } from '@/utils'
import popupMixins from '@/mixins/popupMixins'
import ViewAssets from '@/components/ViewAssets'
import MasterItemTypeAhead from '@/components/MasterItemTypeAhead'

export default {
    name: 'ViewItem',
    components: {
        ViewAssets,
        MasterItemTypeAhead,
    },
    mixins: [popupMixins],
    props: ['orderId'],
    data() {
        return {
            itemVisible: false,
            submitting: false,
            salesTax: 0,
            itemModel: {
                id: null,
                name: '',
                order_item_type_id: null,
                hash: uuidv4(),
                description: '',
                section_from_id: null,
                section_to_id: null,
                quantity: 0,
                price: 0,
            },
        }
    },

    methods: {
        setMasterItem(masterItem) {
            if (!masterItem) return
            console.log('setMasterItem data', masterItem)
            console.log('this.itemModel', this.itemModel)
            this.itemModel.description = masterItem.description
            this.itemModel.name = masterItem.name
            this.itemModel.price = masterItem.selling_price
            this.itemModel.order_item_type_id = masterItem.order_item_type_id
            this.itemModel.quantity = 1
        },
        showItem(item) {
            this.itemVisible = true
            const $this = this
            this.$nextTick(() => {
                $this.itemModel = item
            })
        },

        handleOk(evt) {
            // Prevent modal from closing
            evt.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },

        async handleSubmit() {
            // Exit when the form isn't valid
            try {
                if (!this.itemModel.name) {
                    throw new Error('Name is required')
                }

                if (!this.itemModel.order_item_type_id) {
                    throw new Error('Type is required')
                }

                this.submitting = true
                const item = { ...this.itemModel }
                item.hash =
                    item.hash ||
                    Date.now().toString(36) +
                        Math.random().toString(36).substring(2)
                item.price = parseFloat(item.price) || 0
                item.quantity = parseInt(item.quantity) || 1

                console.log('item:', item)
                const { order_id } = this

                console.log('order_id:', order_id)

                const type =
                    this.itemTypes.find(
                        x => item.order_item_type_id === x.id
                    ) || {}
                item.tax_rate = type.tax_rate
                const id = item.id
                console.log('item', item)
                delete item.id
                const path = id
                    ? 'orders/updateOrderItem'
                    : 'orders/createOrderItem'

                await this.$store.dispatch(path, {
                    order_id,
                    item,
                    id,
                })
                this.itemVisible = false
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.submitting = false
            }
        },
    },

    mounted() {
        this.$store.dispatch('orders/fetchOrderItems', this.order_id)
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('itemType/fetchAll')
    },
    computed: {
        order_id() {
            return this.orderId || this.$route.params.id
        },
        submitTitle() {
            return this.itemModel.id && this.submitting
                ? 'Updating Item...'
                : this.itemModel.id
                ? 'Update Item'
                : this.submitting
                ? 'Creating Item...'
                : 'Create Item'
        },
        order() {
            return this.$store.state.orders.item
        },
        itemTypeOptions() {
            return this.itemTypes.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        warehouse_section_options() {
            return this.$store.getters['locations/warehouse_sections'].map(
                x => ({
                    value: x.id,
                    text: x.name,
                })
            )
        },
        orderItems() {
            return this.$store.state.orders.orderItems
        },

        itemTypes() {
            const types = this.$store.state.itemType.items
            console.log('types', types)
            return types
        },
    },
}
</script>
